// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"video-camera-dollar"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M1 5L0.999999 19L16 19L16 5L1 5Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M23 5.99805L16 10.198V13.998L23 17.998V5.99805Z"}},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M23 5.99805L16 10.198L16 13.998L23 17.998V5.99805Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M1 4.99805L1 18.998L16 18.998L16 4.99805L1 4.99805Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M10.5 9H8.5M8.5 9H7.5C6.94772 9 6.5 9.44772 6.5 10V11C6.5 11.5523 6.94772 12 7.5 12H9.5C10.0523 12 10.5 12.4477 10.5 13V14C10.5 14.5523 10.0523 15 9.5 15H8.5M8.5 9V8M8.5 15H6.5M8.5 15L8.5 16","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const VideoCameraDollarIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'video-camera-dollar',
    ref,
    icon: element,
  },
));

VideoCameraDollarIcon.displayName = 'VideoCameraDollarIcon';

export default VideoCameraDollarIcon;
